export default __webpack_public_path__ + "static/media/brian_spain.56aee9ff.jpg";